type Props = {
  size: number;
  color?: string;
};

const Parking = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3334 1.5C22.1618 1.5 22.8334 2.17157 22.8334 3V21C22.8334 21.8284 22.1618 22.5 21.3334 22.5H3.33337C2.50495 22.5 1.83337 21.8284 1.83337 21V3C1.83337 2.17157 2.50495 1.5 3.33337 1.5H21.3334ZM3.33337 21H21.3334V3H3.33337V21ZM11.64 6C13.0826 6 14.0232 6.05922 14.4613 6.17676C15.1342 6.35306 15.6977 6.73732 16.1517 7.33008C16.6058 7.91775 16.8333 8.67934 16.8334 9.61426C16.8334 10.3355 16.7026 10.9421 16.4408 11.4336C16.179 11.9251 15.8449 12.3125 15.4388 12.5957C15.0381 12.8735 14.629 13.0576 14.2123 13.1484C13.646 13.2606 12.826 13.3174 11.7523 13.3174H10.2054V17.749H7.83337V6H11.64ZM10.2054 11.3213H11.5043C12.4391 11.3213 13.0641 11.2596 13.3793 11.1367C13.6943 11.0139 13.9403 10.8222 14.1166 10.5605C14.2982 10.2987 14.389 9.99377 14.389 9.64648C14.389 9.21906 14.2632 8.86669 14.0121 8.58887C13.761 8.3111 13.4435 8.13687 13.059 8.06738C12.7758 8.01396 12.2066 7.98731 11.3519 7.9873H10.2054V11.3213Z"
        fill={color || '#868686'}
      />
    </svg>
  );
};

export default Parking;
